import { toast } from 'react-toastify';

import { createServicesLink } from './services';

import {
  handleServicesLink,
  clearServicesLinkErrors,
  setServicesLinkErrors
} from './actions';

export const registerServicesLink = (userId, establishmentId, clientId, params) => dispatch => {
  dispatch(handleServicesLink(true));

  return createServicesLink(userId, establishmentId, clientId, params)
    .then(() => {
      dispatch(clearServicesLinkErrors());
      toast.success('Vinculo cadastrado com sucesso');
    })
    .catch(error => {
      if(!error) {
        dispatch(clearServicesLinkErrors());
        toast.error('Houve um erro ao vincular o serviço.');
        return Promise.reject();
      }

      dispatch(setServicesLinkErrors(error));

      return Promise.reject(error);
    })
    .finally(() => dispatch(handleServicesLink(false)));
}